/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputAdminPositionStockBalance } from './OutputAdminPositionStockBalance';
import {
    OutputAdminPositionStockBalanceFromJSON,
    OutputAdminPositionStockBalanceFromJSONTyped,
    OutputAdminPositionStockBalanceToJSON,
} from './OutputAdminPositionStockBalance';
import type { OutputAdminPositionStockMovement } from './OutputAdminPositionStockMovement';
import {
    OutputAdminPositionStockMovementFromJSON,
    OutputAdminPositionStockMovementFromJSONTyped,
    OutputAdminPositionStockMovementToJSON,
} from './OutputAdminPositionStockMovement';

/**
 * 
 * @export
 * @interface OutputAdminPositionStockResponse
 */
export interface OutputAdminPositionStockResponse {
    /**
     * 
     * @type {Array<OutputAdminPositionStockBalance>}
     * @memberof OutputAdminPositionStockResponse
     */
    balance?: Array<OutputAdminPositionStockBalance>;
    /**
     * 
     * @type {Array<OutputAdminPositionStockMovement>}
     * @memberof OutputAdminPositionStockResponse
     */
    movements?: Array<OutputAdminPositionStockMovement>;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the OutputAdminPositionStockResponse interface.
 */
export function instanceOfOutputAdminPositionStockResponse(value: object): boolean {
    return true;
}

export function OutputAdminPositionStockResponseFromJSON(json: any): OutputAdminPositionStockResponse {
    return OutputAdminPositionStockResponseFromJSONTyped(json, false);
}

export function OutputAdminPositionStockResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminPositionStockResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'] == null ? undefined : ((json['balance'] as Array<any>).map(OutputAdminPositionStockBalanceFromJSON)),
        'movements': json['movements'] == null ? undefined : ((json['movements'] as Array<any>).map(OutputAdminPositionStockMovementFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function OutputAdminPositionStockResponseToJSON(value?: OutputAdminPositionStockResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'balance': value['balance'] == null ? undefined : ((value['balance'] as Array<any>).map(OutputAdminPositionStockBalanceToJSON)),
        'movements': value['movements'] == null ? undefined : ((value['movements'] as Array<any>).map(OutputAdminPositionStockMovementToJSON)),
        'total': value['total'],
    };
}

